import { cn } from '@baiocchi/ui'

/**
 * Logo da Baiocchi.
 *
 * O arquivo é `logo.png` da raiz do projeto, copiado para `public/`. Tem fundo
 * branco chapado, então no tema escuro ele apareceria como um retângulo aceso: a
 * variante `compacta` usa apenas o símbolo, com `mix-blend-mode: multiply` no tema
 * claro, e no escuro entra o lettering em texto — a marca continua reconhecível
 * sem o bloco branco.
 * ⚠️ Pendente: pedir o SVG com fundo transparente ao design.
 */
export function Marca({
  variante = 'completa',
  className,
}: {
  variante?: 'completa' | 'compacta'
  className?: string
}) {
  if (variante === 'compacta') {
    return (
      <span
        className={cn(
          'inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-marca-500 text-lg font-bold text-white',
          className,
        )}
        aria-hidden="true"
      >
        B
      </span>
    )
  }

  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <img
        src="/logo.png"
        alt="Baiocchi Leads"
        className="logo-marca h-9 w-9 rounded-md object-cover object-center"
        style={{ objectPosition: '50% 32%' }}
      />
      <span className="flex flex-col leading-none">
        <span className="text-sm font-bold uppercase tracking-wide text-conteudo">Baiocchi</span>
        <span className="text-[0.6875rem] font-semibold uppercase tracking-[0.2em] text-marca-500">
          Leads
        </span>
      </span>
    </span>
  )
}
